import React from "react";
import { Section, FadeUp, SectionHeading } from "./primitives";
import { coachCredentials, media } from "@/data/content";

export const Coach = () => (
  <Section className="bg-white">
    <div className="max-w-[1100px] mx-auto grid gap-12 lg:grid-cols-2 lg:items-start">
      <FadeUp className="order-1">
        <div className="relative rounded-xl overflow-hidden border border-zinc-200 shadow-md">
          <img
            src={media.coach}
            alt="Doug - Full Time Guitar coach holding a Fender Stratocaster"
            loading="lazy"
            className="w-full h-full object-cover aspect-[4/5]"
          />
        </div>
      </FadeUp>

      <FadeUp delay={0.05} className="order-2">
        <SectionHeading>Meet Your Coach</SectionHeading>
        <div className="mt-6 space-y-5 text-lg text-zinc-600 leading-relaxed">
          <p>I'm Doug.</p>
          <p>
            I was born and raised in Wales, and I was completely self-taught when I first picked up a guitar,
            much like a lot of you reading this.
          </p>
          <p>
            Inspired by my guitar heroes to keep improving, I eventually studied guitar for an HND, then a full
            degree at the Brighton Institute of Modern Music.
          </p>
          <p>
            While I was there, I attended seminars with players like Guthrie Govan, Billy Sheehan, and Andy
            McKee, and learned from tutors including Damien Morris and Paul Bielatowicz.
          </p>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {coachCredentials.map((c) => (
            <div key={c.title} className="border-l-2 border-[#D90429] pl-4">
              <h3 className="font-bold text-zinc-900">{c.title}</h3>
              <p className="mt-1 text-base text-zinc-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </FadeUp>
    </div>
  </Section>
);
